import { createSlice } from '@reduxjs/toolkit'
import { requests } from '../../../core/ajax'

const ipSlice = createSlice({
  name: 'ip',
  initialState: {
    isLoading: false,
    data: [],
    search: {},
    pagination: {},
  },
  reducers: {
    setLoading: (state, { payload }) => {
      state.isLoading = payload
    },
    setIPData: (state, { payload }) => {
      state.data = payload.data
      if (payload.search) {
        state.search = payload.search
      }
      if (payload.pagination) {
        state.pagination = payload.pagination
      }
      state.isLoading = false
    },
  },
})

export const ipReducer = ipSlice.reducer

export const { setLoading, setIPData } = ipSlice.actions

export const getIPs = (searchParams, isGuild) => (dispatch) => {
  const { _pagina = 1, _num_x_pagina = 20, ...restSearchParams } = searchParams
  const { get } = requests

  const config = {
    params: { ...restSearchParams, _pagina, _num_x_pagina },
  }

  const endpoint = isGuild ? '/inspecciones/tabla_gremios' : '/inspecciones/tabla_instaladores'
  dispatch(setLoading(true))
  get(endpoint, config)
    .then(({ data }) => {
      dispatch(
        setIPData({
          data: data.registros,
          search: searchParams,
          pagination: {
            total_paginas: data['total_paginas'],
            total_registros: data['total_registros'],
          },
        })
      )
    })
    .catch(({ response }) => {
      console.error('Error recuperando IPs', response)
      dispatch(setLoading(false))
    })
}
